import { render, staticRenderFns } from "./propertyStatusListing.vue?vue&type=template&id=508b6116&"
import script from "./propertyStatusListing.vue?vue&type=script&lang=js&"
export * from "./propertyStatusListing.vue?vue&type=script&lang=js&"
import style0 from "./propertyStatusListing.vue?vue&type=style&index=0&id=508b6116&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports